// A way on from every home, so a visit needn't end at the first one (climb round 4): a pill over the
// scene for next door. Words only, so a home's frame rate is what it was. The row in the Story, "From
// here", went in round 6: no click in seven runs, with or without who's there; the plaque's line drew them.
import { shell, isPhone } from './shell.js';

type Isle = { slug: string; name: string; emoji?: string; distance?: number };
const el = (tag: string, cls = '', text = '') => { const e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; };

const near = new Map<string, Isle[]>();
async function nextDoor(slug: string): Promise<Isle[]> {
  if (near.has(slug)) return near.get(slug) as Isle[];
  try {
    const r = await fetch(`/api/house/${encodeURIComponent(slug)}/neighbourhood?light`);
    const d = r.ok ? await r.json() : null;
    const list: Isle[] = (d?.islands || []).slice().sort((a: Isle, b: Isle) => (a.distance ?? 9) - (b.distance ?? 9)).slice(0, 2);
    near.set(slug, list);
    return list;
  } catch { return []; }
}

const css = `.pz-next{display:inline-flex;align-items:center;gap:6px;min-height:44px;box-sizing:border-box;padding:0 14px;border-radius:999px;background:var(--pz-paper,#fffaf0);color:var(--pz-ink,#3a2a20);font-weight:800;font-size:15px;text-decoration:none;box-shadow:0 8px 16px -10px rgba(40,26,14,.7),inset 0 0 0 1px var(--pz-rule,#e2d4ba);max-width:min(260px,66vw);line-height:1.2;text-align:left}
.pz-next:after{content:"›";font-size:18px;line-height:1}
.pz-next[hidden]{display:none}
button.pz-next{border:none;cursor:pointer;font-family:inherit}`;

// the resident is out: a way to go after it, beside Next door. It can be asked for before the pill exists.
type Away = { label: string; onClick: () => void } | null;
let awayBtn: HTMLButtonElement | null = null, awayNow: Away = null;
export function awayPill(a: Away) {
  awayNow = a;
  if (!awayBtn) return;
  awayBtn.hidden = !a;
  if (a) { awayBtn.textContent = a.label; awayBtn.onclick = a.onClick; }
}

export function onward(go: (slug: string) => boolean) {
  const sh = shell();
  const style = document.createElement('style'); style.textContent = css; document.head.append(style);
  const pill = el('a', 'pz-next') as HTMLAnchorElement;
  pill.dataset.ux = 'next-door'; pill.hidden = true;
  awayBtn = el('button', 'pz-next') as HTMLButtonElement;
  awayBtn.type = 'button'; awayBtn.dataset.ux = 'follow-away'; awayBtn.hidden = true;
  sh.ctx('br', awayBtn); sh.ctx('br', pill);
  awayPill(awayNow);
  let token = 0;
  const show = async (slug: string) => {
    const mine = ++token;
    const list = await nextDoor(slug);
    if (mine !== token) return;
    const n = list[0];
    if (n) {
      pill.textContent = `Next door: ${n.name}`;
      pill.href = `/@${encodeURIComponent(n.slug)}`; pill.hidden = false;
      pill.onclick = (e) => { if (go(n.slug)) e.preventDefault(); };
    } else pill.hidden = true;
  };
  // (a phone's bottom corner is the dock's: it sits up a little from the sheet)
  if (isPhone()) pill.style.marginBottom = '4px';
  return { show };
}
